import styled, { css } from "styled-components";
import Action from "../Action";

const LinkStyled = styled(Action)`
  display: ${({ display }) => display};
  text-underline-offset: 0.17rem;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }

  &:active {
    text-decoration: none;
  }
  ${({ disabled }) =>
    disabled ? css({ textDecoration: "none", cursor: "default" }) : null}
`;

export const PrimaryLinkStyled = styled(LinkStyled)(({ theme }) => ({
  color: theme.color.brandPrimary.light,
}));

export default LinkStyled;
